module.exports = __webpack_public_path__ + "img/top_bg.9047cb7f.png";